"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { normalizeAudioOperation } from "../_operations/normalizeAudio";

export function NormalizeAudioContent() {
  return <MediaWorkspace operation={normalizeAudioOperation} />;
}
